/* eslint eqeqeq: "off" */
import React from 'react';
import toastr from 'toastr';
import { Segment} from 'semantic-ui-react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {getMargenes} from '../../util/';
import ModalFinSession from './ModalFinSession';
import * as finSessionActions from '../../actions/finSessionActions';


  
class ManageFinSession extends React.Component {
	constructor(props, context) {		
		super(props, context);	
        
		this.onRenovarSession = this.onRenovarSession.bind(this);
        
	}
	
	onRenovarSession(){
      
		this.props.finSessionActions.renuevaSessionUser().then(()=>{
			toastr.success("Tiempo de sesión renovado.");
		})
        .catch(error=>{
          toastr.error(error);
        });
	}
    
    
   
   
	
	componentWillReceiveProps(nextProps) {
		
			  this.setState({
				  showModalAvisoFinSession: Object.assign({}, nextProps.showModalAvisoFinSession)		  
			  });
             //console.log("entro a habilitar la venta");
	  }
	
	render() {	
		let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
        
		return (
			<div>

			<ModalFinSession 
				showModal={this.props.showModalAvisoFinSession}
				onRenovarSession={this.onRenovarSession}
				/>
			</div> 
			
		);
	}
};


function mapStateToProps(state, ownProps){
	
    return {
      showModalAvisoFinSession: state.showModalAvisoFinSession
    }

}

function mapDispatchToProps(dispatch){
	return {   
        finSessionActions: bindActionCreators(finSessionActions, dispatch)
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageFinSession);